import { SectionTitle } from '@apps/components/SectionTitle';
import { Grid } from '@mui/material';
import { useGetResponsive } from '@stack/helpers/lib/responsive';

import { EvTestCarCard } from '../EvTestCarCard';

import { EvTestSectionBoxProps } from './props';

export const EvTestSectionBox: React.FC<EvTestSectionBoxProps> = (props) => {
  const { sectionType, sectionData, containerProps, webView } = props;

  const { isMobile } = useGetResponsive();

  const title = sectionType
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

  return (
    <div
      style={{
        padding: '30px',
        backgroundColor: '#ffffff99',
        border: '2px solid #fff',
        borderRadius: '8px',
        ...containerProps,
      }}
    >
      <SectionTitle
        title={
          <p
            style={{
              fontSize: isMobile ? 20 : 24,
              fontWeight: 700,
            }}
          >
            {`${title} `}
            {sectionType === 'top_power_performance' && (
              <span
                style={{
                  whiteSpace: 'nowrap',
                }}
              >
                (0-100km/h)
              </span>
            )}
          </p>
        }
        containerProps={{
          borderLeft: '8px solid #31ACBF',
        }}
      >
        <Grid container spacing={2} columns={5} rowGap={7}>
          {sectionData.map((car) => {
            return (
              <Grid item xs={5} md={1} key={car.new_car_id}>
                <EvTestCarCard
                  key={car.new_car_id}
                  cardType={sectionType}
                  data={car}
                  webView={webView}
                />
              </Grid>
            );
          })}
        </Grid>
      </SectionTitle>
    </div>
  );
};
